import { render, staticRenderFns } from "./CorpPolityContractPage.vue?vue&type=template&id=78595818"
import script from "./CorpPolityContractPage.vue?vue&type=script&lang=js"
export * from "./CorpPolityContractPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports